import { render, staticRenderFns } from "./PErrorDisplay.vue?vue&type=template&id=79992f66&scoped=true&"
import script from "./PErrorDisplay.vue?vue&type=script&lang=ts&"
export * from "./PErrorDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./PErrorDisplay.vue?vue&type=style&index=0&id=79992f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79992f66",
  null
  
)

export default component.exports